import { toLocaleTextAsDate } from "@/shared/lib/datetime";
import { Typography } from "@mui/material";

type Props = {
  date: Date;
};

export const NotificationDateTitle = ({ date }: Props) => {
  // MM/dd(曜日)で表示する
  return (
    <Typography fontSize="18px" fontWeight={700}>
      {toLocaleTextAsDate(date, true)}
    </Typography>
  );
};
